import {makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    cardContainer:{
        background:'black',
        maxWidth:'600px',
        margin:'100px auto',
        paddingLeft: '50px',
        paddingRight: '60px',
        // border: '1px solid black'
    }
}));